import React, { useEffect, useMemo } from "react"
import withFunctionCall from "#utils/withFunctionCall"
import { Modal, Table } from "@bedrock/components"
import KPITable, { KPITableProps } from "./index"
import { DemandKpiValueDto } from "#services/api";

interface Props extends KPITableProps {
    visible: boolean;
    onCancel: () => void;
    value: any
    title: string
}

// 第三方数据弹框
const ThirdPartyDataModal = (props: Props) => {
    const { visible, onCancel, view, value, title } = props;
    const data = useMemo(() => {
        const { actual_value_extra, actual_value, result_extra, result } = value
        // actual_value_extra 含三方
        // actual_value 不含三方
        return ['actual_value_extra', 'actual_value'].map((item) => {
            return {
                ...value,
                result: item == 'actual_value' ? result : result_extra,
                $valueType: item,
                $isShowThirdDataText: false
            }
        })
    }, value)

    return <Modal
        title={title}
        visible={visible} onCancel={onCancel}
        footer={<div>{' '}</div>}
    >
        <KPITable {...props} view={view} value={data} />
    </Modal>
}
export default withFunctionCall(ThirdPartyDataModal)